import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Col } from '@amzn/atoz-web/Col';
export var SpecialInstructions = function (_a) {
    var specialInstructions = _a.specialInstructions;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null, !!specialInstructions && (React.createElement(Col, { dataTestId: "SpecialInstructions", gridGap: "S200" },
        React.createElement(Text, { fontWeight: "bold" }, t('shift_management_features_ShiftDetailsModal_specialInstructions')),
        React.createElement(SpecialInstructionsCard, null,
            React.createElement(Text, { fontSize: "T100", dataTestId: "SpecialInstructionsText" }, specialInstructions))))));
};
var SpecialInstructionsCard = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return " \n    box-shadow: 0px 0px 5px 1px ".concat(theme.selectors.color('neutral20'), ";\n    padding: ").concat(theme.selectors.space('S300'), "px;\n    ");
});
